import { ArrowRight } from 'lucide-react';
import { cn } from '@perch/ui-tokens';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { buttonVariants, SectionLabel } from '@perch/ui';

export function PricingSection() {
  const section = useScrollReveal();

  return (
    <section id="pricing" className="relative py-32 px-4 sm:px-6 bg-stone-100 dark:bg-stone-800 scroll-mt-20">
      <div
        ref={section.ref}
        className={`max-w-2xl mx-auto text-center transition-[opacity,transform] duration-500 ease-out ${section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      >
        <SectionLabel className="mb-10">Pricing</SectionLabel>

        {/* The number IS the headline */}
        <div className="mb-8">
          <span className="text-7xl sm:text-8xl font-data tabular-nums text-emerald-600 dark:text-emerald-400">$247</span>
          <p className="text-lg text-stone-500 dark:text-stone-400 mt-2">avg. saved per trip</p>
        </div>

        <div className="w-12 h-px bg-stone-300 dark:bg-stone-600 mx-auto mb-8" />

        <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed mb-3">
          We only get paid when you save.
          15% of what we find. You keep the rest.
        </p>
        <p className="text-stone-500 dark:text-stone-400 mb-10">
          If we find nothing, you pay nothing. Ever.
        </p>

        <a
          href="#waitlist"
          className={cn(buttonVariants({ variant: 'coral', size: 'lg' }), 'group gap-3')}
        >
          Start Tracking Free
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </a>

        <p className="text-sm text-stone-400 dark:text-stone-500 mt-6">
          Pay for results, not promises.
        </p>
      </div>
    </section>
  );
}
